// src/components/DesignationPickerModal.jsx
// src/components/DesignationPickerModal.jsx
import React, { useMemo, useState } from "react";
import { useDesignations } from "../hooks/useDesignations";
import axios from "../axiosInstance";

export default function DesignationPickerModal({ open, onClose, onSelect, allowCreate = true }) {
    // ✅ Tous les hooks doivent être appelés à chaque render
    const { items, loading, refetch } = useDesignations();
    const [q, setQ] = useState("");
    const [create, setCreate] = useState({ label: "", prixUnitaire: 0, tva: 20, type: "materiaux" });

    const filtered = useMemo(() => {
        const n = q.trim().toLowerCase();
        const list = n ? items.filter(i => (i.label || "").toLowerCase().includes(n)) : items;
        return list.slice().sort((a, b) => (a.label || "").localeCompare(b.label || "", "fr", { sensitivity: "base" }));
    }, [items, q]);

    // ✅ Le guard APRÈS les hooks
    if (!open) return null;

    const handleCreate = async () => {
        if (!create.label.trim()) return;
        await axios.post("/designations", {
            label: create.label.trim(),
            prixUnitaire: Number(create.prixUnitaire || 0),
            tva: Number(create.tva ?? 20),
            titre: create.label.trim(),
            prix: Number(create.prixUnitaire || 0),
            type: create.type
        });
        await refetch();
        const just = filtered.find(x => x.label === create.label) || { ...create, id: undefined };
        onSelect?.(just);
        onClose?.();
    };

    return (
        <div className="fixed inset-0 z-[1000] bg-black/40 flex items-center justify-center">
            <div className="bg-white w-full max-w-2xl rounded-xl shadow-lg p-4">
                <div className="flex items-center justify-between mb-3">
                    <h2 className="text-lg font-semibold">Choisir une désignation</h2>
                    <button onClick={onClose} className="px-2 py-1 rounded border">Fermer</button>
                </div>

                <input
                    autoFocus
                    value={q}
                    onChange={(e) => setQ(e.target.value)}
                    placeholder="Rechercher..."
                    className="w-full border rounded px-3 py-2 mb-3"
                />

                <div className="max-h-72 overflow-auto border rounded">
                    {loading ? (
                        <div className="p-4 text-center text-gray-500">Chargement…</div>
                    ) : filtered.length === 0 ? (
                        <div className="p-4 text-center text-gray-500">Aucune désignation.</div>
                    ) : (
                        <ul>
                            {filtered.map(it => (
                                <li key={it.id}
                                    className="px-3 py-2 border-b hover:bg-gray-50 cursor-pointer flex justify-between"
                                    onClick={() => { onSelect?.(it); onClose?.(); }}>
                                    <span className="font-medium">{it.label}</span>
                                    <span className="text-sm text-gray-600">
                                        {it.prixUnitaire.toFixed(2)} € • TVA {it.tva}%
                                    </span>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>

                {allowCreate && (
                    <>
                        <div className="mt-4 grid grid-cols-[1fr_120px_100px_160px] gap-2">
                            <input className="border rounded px-2 py-2" placeholder="Nouvelle désignation"
                                value={create.label} onChange={e => setCreate({ ...create, label: e.target.value })} />
                            <input type="number" step="0.01" className="border rounded px-2 py-2 text-right"
                                placeholder="PU HT" value={create.prixUnitaire}
                                onChange={e => setCreate({ ...create, prixUnitaire: e.target.value })} />
                            <input type="number" step="0.1" className="border rounded px-2 py-2 text-right"
                                placeholder="TVA" value={create.tva}
                                onChange={e => setCreate({ ...create, tva: e.target.value })} />
                            <div className="flex gap-2">
                                <select className="border rounded px-2 py-2" value={create.type}
                                    onChange={e => setCreate({ ...create, type: e.target.value })}>
                                    <option value="materiaux">Matériaux</option>
                                    <option value="main_oeuvre">Main d’œuvre</option>
                                </select>
                                <button className="bg-sky-700 hover:bg-sky-600 text-white px-4 py-2 rounded"
                                    onClick={handleCreate}>Créer</button>
                            </div>
                        </div>
                        <p className="mt-2 text-xs text-gray-500">Astuce : crée et sélectionne d’un coup.</p>
                    </>
                )}
            </div>
        </div>
    );
}


